import Button from "@app/sharedComponents/Button/Button";
import { ThemedText, ThemedView } from "@app/theme";
import { LENDER_ID } from "@app/types/regix";
import { Image } from "react-native";
const INFO_1 ="https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png"
const INFO_2 = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/withdraw_cash.png"
const HowRenewWork = ({closeBottomSheet})=> {
    return(
        <ThemedView p="lg" backgroundColor="bg-surface-primary">
            <ThemedText variant="b2s" color="text-primary" mb="lg">
                How loan renewal works?
            </ThemedText>
            <ThemedView mb="2xl" flexDirection="row" alignItems="center">
                <Image source={{uri:INFO_1}} style={{width:40,height:40}} />
                <ThemedView ml="md">
                    <ThemedText variant="b3m" color="text-primary">Just confirm that you want to renew</ThemedText>
                    <ThemedText variant="b4r" color="text-secondary">Loan will be auto renewed on maturity date</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView mb="2xl" flexDirection="row" alignItems="center">
                <Image source={{uri:INFO_2}} style={{width:40,height:40}} />
                <ThemedView ml="md">
                    <ThemedText variant="b3m" color="text-primary">Start using your credit limit</ThemedText>
                    <ThemedText variant="b4r" color="text-secondary">Withdraw cash flexibly </ThemedText>
                </ThemedView>
            </ThemedView>
            <Button label="Ok, got it!" size="MD" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}
export default HowRenewWork